export default {
  root: ({ props, state, parent }) => ({
    class: [
      // Display and Position
      'inline-flex',
      'relative',
      'py-1.5',
      'w-full',
      // Shape
      { 'rounded-lg': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md':
          parent.instance.$name == 'InputGroup',
      },
      {
        'border-0 border-y border-l last:border-r':
          parent.instance.$name == 'InputGroup',
      },
      {
        'first:ml-0 ml-[-1px]':
          parent.instance.$name == 'InputGroup' && !props.showButtons,
      },

      // Color and Background
      { 'bg-base': !props.disabled },

      'border',
      { 'stacked-border': parent.instance.$name != 'InputGroup' },
      { 'stacked-border': parent.instance.$name == 'InputGroup' },
      { 'stacked-border': !props.invalid },

      // Invalid State
      'invalid:focus:ring-error-200',
      'invalid:hover:border-error-500',
      {
        'outline-none outline-offset-0 ring-1 ring-error-500 dark:ring-error-500':
          props.invalid,
      },

      // Transitions
      'transition-all',
      'duration-200',

      {
        'outline-none outline-offset-0 ring-1 ring-primary-blue-500 dark:ring-primary-blue-400 z-[15]':
          state.focused && !props.invalid,
      },

      // Misc
      'cursor-pointer',
      'select-none',
      {
        'bg-surface-200 dark:bg-surface-700 select-none pointer-events-none cursor-default':
          props.disabled,
      },
    ],
  }),
  label: ({ props, parent }) => ({
    class: [
      //Font
      'leading-[normal]',

      // Display
      'block',
      'flex-auto',

      // Color and Background
      'bg-transparent',
      'border-0',
      {
        'text-base-priority': props.modelValue != undefined,
        'text-dark-700/60 dark:text-light-50/30': props.modelValue == undefined,
      },
      'placeholder:text-dark-700/60 dark:placeholder:text-light-50/30',

      // Sizing and Spacing
      'w-full',
      'py-1.5 px-3',
      { 'pr-7': props.showClear },

      //Shape
      'rounded-none',

      // Transitions
      'transition',
      'duration-200',

      // States
      'focus:outline-none focus:shadow-none',

      // Filled State *for FloatLabel
      {
        filled:
          parent.instance?.$name == 'FloatLabel' && props.modelValue !== null,
      },

      // Misc
      'relative',
      'cursor-pointer',
      'overflow-hidden overflow-ellipsis',
      'whitespace-nowrap',
      'appearance-none',
    ],
  }),
  dropdown: ({ state }) => {
    return {
      class: [
        // Flexbox
        'flex items-center justify-center',
        'shrink-0',

        // Color and Background
        'bg-transparent',
        'text-dark-700/60 dark:text-light-50/30',
        // Size
        'w-12',

        // Shape
        'rounded-r-md',
        // Padding
        'px-2',

        //State
        'transition duration-200',
        { '-rotate-180': state.overlayVisible },
      ],
    };
  },
  overlay: (ctx) => {
    const width = ctx?.attrs?.width
      ? `!max-w-[${ctx?.attrs?.width}px] !w-[${ctx?.attrs?.width}px]`
      : 'w-full';
    return {
      class: [
        // Colors
        'bg-base',
        // Shape
        'stacked-border',
        'rounded-lg',
        'shadow-md',
        //fix off center positioning
        width,
        '!z-[1104]',
      ],
    };
  },
  listContainer: {
    class: [
      // Sizing
      'max-h-[200px]',

      // Misc
      'overflow-auto',
    ],
  },
  list: {
    class: 'p-0 list-none m-0',
  },
  option: ({ context }) => ({
    class: [
      'relative',
      'flex items-center',
      'truncate text-ellipsis',

      // Font
      'leading-none',

      // Spacing
      'm-0 px-3 py-2',
      'first:mt-0 mt-[2px]',
      // Shape
      'border-0 rounded',
      // Colors
      {
        'text-dark-700/60 dark:text-light-50/60':
          (context.focused && !context.selected) ||
          (!context.focused && !context.selected),
        'bg-primary-blue-gradient !text-light-50': context.selected,
      },

      //States
      {
        'hover:bg-surface-100 dark:hover:bg-[rgba(255,255,255,0.03)]':
          !context.focused && !context.selected,
      },
      { 'hover:bg-highlight-emphasis': context.selected },
      {
        'hover:text-surface-700 hover:bg-surface-100 dark:hover:text-light-50 dark:hover:bg-[rgba(255,255,255,0.03)]':
          context.focused && !context.selected,
      },

      // Transition
      'transition-shadow duration-200',

      // Misc
      'cursor-pointer overflow-hidden whitespace-nowrap',
    ],
  }),
  optionGroup: {
    class: [
      'font-semibold',

      // Spacing
      'm-0 py-2 px-3',

      // Colors
      'text-surface-400 dark:text-surface-500',

      // Misc
      'cursor-auto',
    ],
  },
  optionCheckIcon:
    'relative -ms-1.5 me-1.5 text-surface-700 dark:text-light-50/80 w-4 h-4',
  optionBlankIcon: 'w-4 h-4',
  emptyMessage: {
    class: [
      // Font
      'leading-none',

      // Spacing
      'py-2 px-3',

      // Color
      'text-surface-800 dark:text-light-50/80',
      'bg-transparent',
    ],
  },
  header: {
    class: [
      // Spacing
      'pt-2 px-2 pb-0',
      'm-0',

      //Shape
      'border-b-0',
      'rounded-tl-md',
      'rounded-tr-md',

      // Color
      'text-surface-700 dark:text-light-50/80',
      'bg-surface-0 dark:bg-surface-900',
      'border-surface-300 dark:border-surface-700',
    ],
  },
  clearIcon: {
    class: [
      // Color
      'text-surface-400 dark:text-surface-500',

      // Position
      'absolute',
      'top-1/2',
      'right-12',

      // Spacing
      '-mt-2',
    ],
  },
  loadingIcon: {
    class: 'text-surface-400 dark:text-surface-500 animate-spin',
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
